import React, { useContext, useEffect, useState } from 'react';
import {
  getInstitutionsType,
  getLanguagesType,
  getPaymentsTypes,
  getSubscriptionsTypes,
  getInstitutionByTypeId,
  updateInstitution,
  deleteInstitution,
} from '../../../actions';
import { Context } from '../../../defaults';
import { groupBy } from '../../../utils';
import InstitutionsTable from './InstitutionsTable';
import { InstitutionsAdd } from './InstitutionsAdd';
import {
  Tabs,
  TreeSelect,
  Row,
  Col,
  Select,
  Empty,
  Form,
  Input,
  Card,
  Descriptions,
  Popconfirm,
  Tooltip,
  Switch,
  message,
} from 'antd';
import {
  CarryOutTwoTone,
  DeleteTwoTone,
  EditOutlined,
  EditTwoTone,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { lang } from 'moment';
import TextArea from 'antd/lib/input/TextArea';

import './index.css';

const { TabPane } = Tabs;
const { TreeNode } = TreeSelect;

const Institutions = () => {
  const { dictionary, language, setLoading } = useContext(Context);
  const [form] = Form.useForm();
  const [active, setActive] = useState('1');
  const [added, setAdded] = useState(false);
  const [institutionsType, setInstitutionsType] = useState();
  const [languagesType, setLanguagesType] = useState();
  const [paymentsTypes, setPaymentsTypes] = useState();
  const [subscriptionsType, setSubscriptionsType] = useState();
  const [selectedInstitutionType, setSelectedInstitutionType] = useState();
  const [groupedInstitutions, setGroupedInstitutions] = useState({});
  const [institutions, setInstitutions] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState();
  const [edit, setEdit] = useState(false);

  const callback = (key) => {
    setActive(key);
    setAdded(false);
  };

  const onSelectInstitution = (value) => {
    setSelectedInstitution('')
    if (value) {
      setSelectedInstitution(institutions.filter((x) => x.id == value)[0]);
    }

  };

  useEffect(() => {
    getInstitutionsType().then(({ data }) => setInstitutionsType(data));
    getLanguagesType().then(({ data }) => setLanguagesType(data));
    getPaymentsTypes().then(({ data }) => setPaymentsTypes(data));
    getSubscriptionsTypes().then(({ data }) => setSubscriptionsType(data));
  }, []);

  const filterInstitutionsByTypeId = (id) => {
    setSelectedInstitution('')
    if (id) {
      setLoading(true);
      getInstitutionByTypeId(id).then((res) => {
        setSelectedInstitutionType(id);
        setGroupedInstitutions(groupBy(res.data, 'city'));
        setInstitutions(res.data);
        setLoading(false);
      });
    }

  };

  const saveEditedInstitution = () => {
    if (
      selectedInstitution.name &&
      selectedInstitution.description &&
      selectedInstitution.langId &&
      selectedInstitution.paymentTypeId &&
      selectedInstitution.institutionTypeId &&
      ((selectedInstitution.paymentTypeId === 1 && selectedInstitution.subscriptionTypeId) ||
        (selectedInstitution.paymentTypeId === 2 && selectedInstitution.studentsCount)) &&
      selectedInstitution.city &&
      selectedInstitution.address &&
      selectedInstitution.studyYearFrom &&
      selectedInstitution.studyYearTo &&
      selectedInstitution.studyYearFrom < selectedInstitution.studyYearTo
    ) {
      setEdit(false);
      updateInstitution(selectedInstitution).then((res) => {
        filterInstitutionsByTypeId(selectedInstitutionType);
        message.success(dictionary?.SuccessfullyChanged[language]);
      });
    } else {
      message.error(dictionary?.FillTheAllRequiredFields[language]);
    }
  };

  const onInputChange = ({ target }) => {
    const { name, value } = target;
    setSelectedInstitution({ ...selectedInstitution, [name]: value });
  };

  const onChange = ({ name, value }) => {
    if (name === 'active') {
      setSelectedInstitution({ ...selectedInstitution, [name]: value ? 1 : 0 });
    } else if (name === 'paymentTypeId') {
      setSelectedInstitution({
        ...selectedInstitution,
        [name]: value,
        studentsCount: null,
        subscriptionTypeId: null,
      });
    } else {
      setSelectedInstitution({ ...selectedInstitution, [name]: value });
    }
  };

  const confirm = () => {
    deleteInstitution(selectedInstitution).then((res) => {
      message.success(dictionary?.OperationSuccessful[language]);
      setSelectedInstitution(null);
      filterInstitutionsByTypeId(selectedInstitutionType);
    });
  };

  const rules = (value, additionalRules = false) => {
    if (additionalRules) {
      if (selectedInstitution.studyYearFrom >= selectedInstitution.studyYearTo)
        return { validateStatus: 'error', help: dictionary?.StudyYearFromLessThanTo[language] };
      else return { validateStatus: 'success', help: null };
    } else {
      if (!value) return { validateStatus: 'error', help: dictionary?.RequiredField[language] };
      else return { validateStatus: 'success', help: null };
    }
  };

  return (
    <div>
      <Tabs defaultActiveKey="1" activeKey={active} onChange={callback}>
        <TabPane tab={`${dictionary?.AddSchool[language]}`} key="1">
          <InstitutionsAdd
            institutionsType={institutionsType}
            paymentsTypes={paymentsTypes}
            languagesType={languagesType}
            subscriptionsType={subscriptionsType}
            setActive={setActive}
            setAdded={setAdded}
          />
        </TabPane>
        <TabPane tab={dictionary?.SchoolsList[language]} key="2">
          <Row style={{ marginTop: '30px' }} gutter={16}>
            <Col span={8}>
              <Select
                placeholder={dictionary?.InstitutionType[language]}
                size="large"
                style={{ width: '100%' }}
                allowClear={true}
                onChange={(value) => filterInstitutionsByTypeId(value)}>
                {institutionsType &&
                  institutionsType.map((el) => {
                    return (
                      <Select.Option value={el.id} key={el.id}>
                        {el.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            </Col>
            <Col span={16}>
              <TreeSelect
                showSearch
                style={{ width: '100%' }}
                size="large"
                disabled={!selectedInstitutionType}
                value={selectedInstitution?.id}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder={dictionary?.SelectInstitutionOrSearch[language]}
                allowClear
                treeDefaultExpandAll
                onChange={onSelectInstitution}
                filterTreeNode={(search, item) => {
                  return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                }}>
                {groupedInstitutions &&
                  Object.keys(groupedInstitutions).map((key) => {
                    return (
                      <TreeNode title={key} key={`city${key}`} disabled>
                        {groupedInstitutions[key].map((value) => {
                          return <TreeNode value={value.id} title={value.name} key={value.id} />;
                        })}
                      </TreeNode>
                    );
                  })}
              </TreeSelect>
            </Col>
          </Row>
          {!selectedInstitution && <Empty style={{ marginTop: '100px' }} />}
          {selectedInstitution && (
            <Card
              style={{ marginTop: '30px' }}
              actions={[
                <Tooltip placement="top" title={dictionary?.Delete[language]}>
                  <Popconfirm
                    placement="bottom"
                    title={dictionary?.AreYouSureToDelete[language]}
                    onConfirm={confirm}
                    okText={dictionary?.Yes[language]}
                    cancelText={dictionary?.No[language]}>
                    <DeleteTwoTone key="delete" twoToneColor="#eb2f96" />
                  </Popconfirm>
                </Tooltip>,
                <Tooltip placement="top" title={dictionary?.Edit[language]}>
                  {!edit && <EditTwoTone key="edit" onClick={() => setEdit(true)} />}
                  {edit && <CarryOutTwoTone key="edit" onClick={saveEditedInstitution} />}
                </Tooltip>,
              ]}>
              <Descriptions
                size="default"
                title={dictionary?.EditInstitution[language]}
                bordered
                column={12}>
                <Descriptions.Item label={dictionary?.Name[language]} span={12}>
                  {edit && (
                    <Form.Item hasFeedback {...rules(selectedInstitution.name)}>
                      <TextArea
                        style={{ width: '100%' }}
                        maxLength={100}
                        showCount={true}
                        size="middle"
                        name="name"
                        onChange={onInputChange}
                        value={selectedInstitution.name}
                        placeholder={dictionary?.Name[language]}
                      />
                    </Form.Item>
                  )}
                  {!edit && selectedInstitution.name}
                </Descriptions.Item>
                <Descriptions.Item label={dictionary?.Description[language]} span={12}>
                  {edit && (
                    <Form.Item hasFeedback {...rules(selectedInstitution.description)}>
                      <TextArea
                        style={{ width: '100%' }}
                        size="middle"
                        name="description"
                        onChange={onInputChange}
                        maxLength={1000}
                        value={selectedInstitution.description}
                        showCount={true}
                        placeholder={dictionary?.Description[language]}
                      />
                    </Form.Item>
                  )}
                  {!edit && selectedInstitution.description}
                </Descriptions.Item>
                <Descriptions.Item label={dictionary?.Lang[language]} span={6}>
                  {edit && (
                    <Form.Item hasFeedback {...rules(selectedInstitution.langId)}>
                      <Select
                        style={{ width: '100%' }}
                        placeholder={dictionary?.Lang[language]}
                        name="langId"
                        onChange={(value) => onChange({ name: 'langId', value })}
                        size="middle"
                        value={selectedInstitution.langId}
                        allowClear={true}>
                        {languagesType &&
                          languagesType.map((el) => {
                            return (
                              <Select.Option value={el.id} key={el.id}>
                                {el.name}
                              </Select.Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  )}
                  {!edit &&
                    selectedInstitution.langId &&
                    languagesType.filter((el) => el.id === selectedInstitution.langId)[0].name}
                </Descriptions.Item>
                <Descriptions.Item label={dictionary?.PaymentType[language]} span={6}>
                  {edit && (
                    <Form.Item hasFeedback {...rules(selectedInstitution.paymentTypeId)}>
                      <Select
                        style={{ width: '100%' }}
                        placeholder={dictionary?.PaymentType[language]}
                        size="middle"
                        name="paymentTypeId"
                        onChange={(value) => onChange({ name: 'paymentTypeId', value })}
                        value={selectedInstitution.paymentTypeId}
                        allowClear={true}>
                        {paymentsTypes &&
                          paymentsTypes.map((el) => {
                            return (
                              <Select.Option value={el.id} key={el.id}>
                                {el.name}
                              </Select.Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  )}
                  {!edit &&
                    selectedInstitution.paymentTypeId &&
                    paymentsTypes.filter((el) => el.id === selectedInstitution.paymentTypeId)[0]
                      .name}
                </Descriptions.Item>
                <Descriptions.Item label={dictionary?.InstitutionType[language]} span={6}>
                  {edit && (
                    <Form.Item hasFeedback {...rules(selectedInstitution.institutionTypeId)}>
                      <Select
                        style={{ width: '100%' }}
                        placeholder={dictionary?.InstitutionType[language]}
                        value={selectedInstitution.institutionTypeId}
                        size="middle"
                        name="institutionTypeId"
                        onChange={(value) => onChange({ name: 'institutionTypeId', value })}
                        allowClear={true}>
                        {institutionsType &&
                          institutionsType.map((el) => {
                            return (
                              <Select.Option value={el.id} key={el.id}>
                                {el.name}
                              </Select.Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  )}
                  {!edit &&
                    selectedInstitution.institutionTypeId &&
                    institutionsType.filter(
                      (el) => el.id === selectedInstitution.institutionTypeId,
                    )[0].name}
                </Descriptions.Item>
                {selectedInstitution.paymentTypeId === 1 && (
                  <Descriptions.Item label={dictionary?.SubscriptionType[language]} span={6}>
                    {edit && (
                      <Form.Item hasFeedback {...rules(selectedInstitution.subscriptionTypeId)}>
                        <Select
                          style={{ width: '100%' }}
                          placeholder={dictionary?.SubscriptionType[language]}
                          value={selectedInstitution.subscriptionTypeId}
                          size="middle"
                          name="subscriptionTypeId"
                          onChange={(value) => onChange({ name: 'subscriptionTypeId', value })}
                          allowClear={true}>
                          {subscriptionsType &&
                            subscriptionsType.map((el) => {
                              return (
                                <Select.Option value={el.id} key={el.id}>
                                  {el.name}
                                </Select.Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    )}
                    {!edit &&
                      selectedInstitution.subscriptionTypeId &&
                      subscriptionsType.filter(
                        (el) => el.id === selectedInstitution.subscriptionTypeId,
                      )[0].name}
                  </Descriptions.Item>
                )}
                {selectedInstitution.paymentTypeId === 2 && (
                  <Descriptions.Item label={dictionary?.NumberOfStudents[language]} span={12}>
                    {edit && (
                      <Form.Item hasFeedback {...rules(selectedInstitution.studentsCount)}>
                        <Input
                          style={{ width: '100%' }}
                          type="number"
                          size="middle"
                          name="studentsCount"
                          onChange={onInputChange}
                          value={selectedInstitution.studentsCount}
                          placeholder={dictionary?.NumberOfStudents[language]}
                        />
                      </Form.Item>
                    )}
                    {!edit && selectedInstitution.studentsCount}
                  </Descriptions.Item>
                )}

                <Descriptions.Item label={dictionary?.City[language]} span={6}>
                  {edit && (
                    <Form.Item hasFeedback {...rules(selectedInstitution.city)}>
                      <Input
                        style={{ width: '100%' }}
                        name="city"
                        onChange={onInputChange}
                        size="middle"
                        value={selectedInstitution.city}
                        placeholder={dictionary?.City[language]}
                      />
                    </Form.Item>
                  )}
                  {!edit && selectedInstitution.city}
                </Descriptions.Item>
                <Descriptions.Item label={dictionary?.IsActive[language]} span={6}>
                  <Switch
                    disabled={!edit}
                    checked={selectedInstitution.active === 1}
                    name="active"
                    onChange={(value) => onChange({ name: 'active', value })}
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={dictionary?.Address[language]} span={6}>
                  {edit && (
                    <Form.Item hasFeedback {...rules(selectedInstitution.address)}>
                      <Input
                        style={{ width: '100%' }}
                        size="middle"
                        name="address"
                        onChange={onInputChange}
                        value={selectedInstitution.address}
                        placeholder={dictionary?.Address[language]}
                      />
                    </Form.Item>
                  )}
                  {!edit && selectedInstitution.address}
                </Descriptions.Item>
                <Descriptions.Item label={dictionary?.YearOfStudy[language]} span={6}>
                  {edit && (
                    <Form.Item
                      hasFeedback
                      {...rules(
                        selectedInstitution.studyYearFrom && selectedInstitution.studyYearTo,
                        true,
                      )}>
                      <Input.Group compact>
                        <Input
                          maxLength={2}
                          type="number"
                          style={{ width: 100, textAlign: 'center' }}
                          value={selectedInstitution.studyYearFrom}
                          onChange={onInputChange}
                          name="studyYearFrom"
                        />
                        <Input
                          className="site-input-split"
                          style={{
                            width: 30,
                            borderLeft: 0,
                            borderRight: 0,
                            pointerEvents: 'none',
                          }}
                          placeholder="~"
                          disabled
                        />
                        <Input
                          maxLength={2}
                          type="number"
                          value={selectedInstitution.studyYearTo}
                          className="site-input-right"
                          name="studyYearTo"
                          onChange={onInputChange}
                          style={{ width: 100, textAlign: 'center' }}
                        />
                      </Input.Group>
                    </Form.Item>
                  )}
                  {!edit &&
                    selectedInstitution.studyYearFrom &&
                    selectedInstitution.studyYearTo &&
                    `${selectedInstitution.studyYearFrom} ~ ${selectedInstitution.studyYearTo}`}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          )}
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Institutions;
